import React from 'react';
import { Loader } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ConfirmationType } from '../../../../../shared/types';
import { useGetContactForm } from '../../../../../shared/hooks';
import { Center } from '../../../../../shared/styles';
import { getText } from '../../../../../shared/text';
import CustomFields from './screens';

const {
  settings: { customfields },
} = getText('EN');

type CustomFieldRoutesProps = {
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
};

const CustomFieldsRoutes = (props: CustomFieldRoutesProps) => {
  const { t } = useTranslation();
  const { setConfirmationData } = props;
  const { path } = useRouteMatch();
  const { data: contactForm = {}, isLoading, isError } = useGetContactForm();
  if (isError)
    return (
      <>
        <Center minHeight="calc(100vh - 88px)">
          {t(`${customfields?.layout?.error}`)}
        </Center>
      </>
    );

  return isLoading ? (
    <>
      <Center minHeight="calc(100vh - 88px)">
        <Loader />
      </Center>
    </>
  ) : (
    <>
      <Switch>
        <Route path={`${path}/`}>
          <CustomFields
            setConfirmationData={setConfirmationData}
            contactForm={contactForm}
          />
        </Route>
      </Switch>
    </>
  );
};

export default CustomFieldsRoutes;
